import React, { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';

const MajorContractsMain = lazy(
  () => import('../major-contracts/MajorContractsMain')
);
const MjAwardBonusPackages = lazy(
  () => import('../major-contracts/MjAwardBonusPackages/MjAwardBonusPackages')
);
const AwardEntryForm = lazy(
  () => import('../major-contracts/AwardEntry/AwardEntryForm')
);

export default [
  {
    id: NavConfig.groupConfigs.MAJOR_CONTRACTS.id,
    path: NavConfig.groupConfigs.MAJOR_CONTRACTS.to,
    element: (
      <MajorContractsMain>
        <Suspense>
          <Outlet />
        </Suspense>
      </MajorContractsMain>
    ),

    children: [
      {
        index: true,
        element: <Navigate to={NavConfig.linkConfigs.MJ_AWARD_ENTRY.to} />,
      },
      {
        id: NavConfig.linkConfigs.MJ_AWARD_BONUS_PACKAGES.id,
        path: NavConfig.linkConfigs.MJ_AWARD_BONUS_PACKAGES.to,
        element: <MjAwardBonusPackages />,
      },
      {
        id: NavConfig.linkConfigs.MJ_AWARD_ENTRY.id,
        path: NavConfig.linkConfigs.MJ_AWARD_ENTRY.to,
        element: <AwardEntryForm />,
      },
    ],
  },
];
